module.exports = __webpack_public_path__ + "static/media/discover.2149ed51.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/discover.svg
// module id = 1112
// module chunks = 0